import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { useLocation, useHistory } from "react-router-dom";
import { tabs } from "./DataManagementTabs";
import DataManagementTabs from "./DataManagementTabs";
import ProcessingPipeline from "./ProcessingPipeline/ProcessingPipeline";
import { makeStyles } from "tss-react/mui";
import Page from "../../../components/Page";
import Header from "./Header";
import { usePostHog } from "posthog-js/react";
import { CLICK_TAB_ON_DATA_MANAGEMENT } from "../../../utils/posthogEvents";

const useStyles = makeStyles()((theme) => ({
  root: {
    height: "100%",
  },
}));

function DataManagement() {
  const { classes } = useStyles();
  const [currentTab, setCurrentTab] = useState(tabs[0].value);
  const location = useLocation();
  const history = useHistory();
  const posthog = usePostHog();
  useEffect(() => {
    // Get initial tab from URL query params
    const searchParams = new URLSearchParams(location.search);
    const tabParam = searchParams.get("tab");
    if (tabParam) {
      setCurrentTab(parseInt(tabParam));
    }
  }, []);

  function handleTabChange(event, tab) {
    setCurrentTab(tab);
    posthog.capture(CLICK_TAB_ON_DATA_MANAGEMENT, { tab: tab });
    // Update URL with new tab
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("tab", tab);
    history.replace({
      pathname: location.pathname,
      search: searchParams.toString(),
    });
  }

  return (
    <Page title={"Data Management"} className={classes.root}>
      <Box
        height={"100%"}
        overflow={"hidden"}
        display={"flex"}
        flexDirection={"column"}>
        <Header />
        <DataManagementTabs
          currentTab={currentTab}
          onTabChange={handleTabChange}
        />
        {currentTab === tabs[0].value && <ProcessingPipeline />}
      </Box>
    </Page>
  );
}

export default DataManagement;
